<template>
  <section v-if="items.length" class="px-6 py-8 lg:py-[4rem] lg:pl-0 lg:pr-[2.1428571429rem]">
     <div class="mb-6 border-b border-gray-300 pb-[1.07rem] text-ash-200">
     <Heading :level="2" color="text-ash-200">
      You should take this test if you
    </Heading>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-[2.5rem]">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="flex items-start gap-4 bg-ash-700 rounded-[0.8571rem] px-5 py-4"
      >
        <span
          class="flex-shrink-0 mt-1 text-pink-500 font-bold"
          aria-hidden="true"
        >
          <Icon icon="check" size="lg"/>
        </span>
        <p class="text-ash-500">
          {{ item }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { WhoShouldUse } from '~~/shared/types/common'
import Heading from '../../atom/heading.vue'
import Icon from '../../atom/icon.vue'

defineProps<{
  items: WhoShouldUse
}>()
</script>
